import React from "react";


const BreadCrumbAndMenu = ({
    handleViewComparisonReport,    
    handleLinkButtonRedirect,
    handleMenuClick,
    comparisonSelected,
}) => {

    return (
        <div id="navigation" role="navigation">
            <div
                style={{
                    backgroundColor: "rgba(0, 105, 92, 1)",
                    height: "50px",
                    marginTop: "-10px",
                }}
                className="text-left d-none"
            >
                <h1
                    className="container text-white h3"
                    style={{ marginTop: "0px", paddingTop: "5px", cursor: "pointer" }}
                    onClick={(e) => handleLinkButtonRedirect(process.env.REACT_APP_CDI_BASE_URL)}
                >
                    Chronic Disease Indicators
                </h1>
            </div>
            {/* Mobile Menu */}
            <div
                style={{
                    backgroundColor: "rgba(206, 236, 231, 1)",
                    borderTop: "3px solid #4ebaaa",
                    minHeight: "45px",
                }}
                className="text-left pl-1 d-md-none"
            >
                <nav className="navbar pl-3" aria-label="Mobile Navigation">
                    <div className="container">
                        <div className="row position-relative">
                            <div className="dropdown ">
                                <button
                                    className="dropdown-toggle-link btn btn-link nav-link"
                                    type="link"
                                    aria-expanded="false"
                                    onClick={handleMenuClick}
                                >
                                    Menu
                                </button>
                            </div>
                        </div>
                        <div className="container hidden nav-dropdown position-absolute">
                            <ul className="navbar-nav mr-auto black-text-nav-links ">
                                <li className="nav-item ">
                                    <button
                                        className="btn btn-link nav-link "
                                        onClick={(e) =>
                                            handleLinkButtonRedirect(process.env.REACT_APP_CDI_BASE_URL)
                                        }
                                    >
                                        Home
                                    </button>
                                </li>
                                <li className="nav-item">
                                    <button
                                        className="nav-link pr-2"
                                        type="link"
                                        onClick={(e) => handleLinkButtonRedirect("/")}
                                    >
                                        Data Explorer
                                    </button>
                                </li>
                                <li className="nav-item " is-selected={comparisonSelected}>
                                    <button
                                        className="btn btn-link nav-link "
                                        onClick={handleViewComparisonReport}
                                    >
                                        Comparison Report
                                    </button>
                                </li>
                                <li className="nav-item ">
                                    <button
                                        className="btn btn-link nav-link "
                                        onClick={(e) =>
                                            handleLinkButtonRedirect(
                                                process.env.REACT_APP_CDI_DATA_PORTAL_URL,
                                                true
                                            )
                                        }
                                    >
                                        Data Portal
                                    </button>
                                </li>
                            </ul>
                        </div>
                        <ul className="navbar-nav black-text-nav-links t">
                            <li>
                                <button
                                    className="btn btn-link"
                                    onClick={(e) =>
                                        handleLinkButtonRedirect(
                                            process.env.REACT_APP_CDI_HELP_URL,
                                            true
                                        )
                                    }                                    
                                >
                                    Help
                                </button>
                            </li>
                        </ul>
                    </div>
                </nav>
            </div>
            {/* Desktop Menu */}
            <div
                style={{
                    backgroundColor: "white",
                    borderTop: "3px solid #009EC1",
                    height: "45px",
                }}
                className="text-left pl-1 d-none d-md-block"
            >
                <div className="container">
                    <nav
                        className="navbar navbar-expand-md"
                        style={{ marginLeft: "-28px" }}
                        aria-label="Desktop Navigation"
                    >
                        <ul className="navbar-nav mr-auto black-text-nav-links">
                            <li className="nav-item ">
                                <button
                                    className="btn btn-link nav-link "
                                    onClick={(e) =>
                                        handleLinkButtonRedirect(process.env.REACT_APP_CDI_BASE_URL)
                                    }
                                >
                                    Home
                                </button>
                            </li>
                            <li className="nav-item">
                                <button
                                    className="btn btn-link nav-link"
                                    onClick={(e) => handleLinkButtonRedirect("/")}
                                >
                                    Data Explorer
                                </button>
                            </li>
                            <li className="nav-item " is-selected={comparisonSelected}>
                                <button
                                    className="btn btn-link nav-link "
                                    onClick={handleViewComparisonReport}
                                >
                                    Comparison Report
                                </button>
                            </li>
                            <li className="nav-item ">
                                <button
                                    className="btn btn-link nav-link "
                                    onClick={(e) =>
                                        handleLinkButtonRedirect(
                                            process.env.REACT_APP_CDI_DATA_PORTAL_URL,
                                            true
                                        )
                                    }
                                >
                                    Data Portal
                                </button>
                            </li>
                        </ul>
                        <ul className="navbar-nav black-text-nav-links">
                            <li className="nav-item">
                                <button
                                    className="btn btn-link nav-link"
                                    onClick={(e) =>
                                        handleLinkButtonRedirect(
                                            process.env.REACT_APP_CDI_HELP_URL,
                                            true
                                        )
                                    }
                                >
                                    Help
                                </button>
                            </li>
                        </ul>
                    </nav>
                </div>
            </div>
            <div
                style={{ backgroundColor: "rgb(245, 245, 245)", height: "40px" }}
                className="text-left mb-2 mt-2  "
            >
                <div className="container d-print-none d-block">
                    <nav
                        role="navigation"
                        aria-label="Breadcrumb"
                        className="breadcrumbs"
                    >
                        <ul className="breadcrumb pt-0 pt-sm-2">
                            <li className="breadcrumb-item">
                                <button
                                    className="btn btn-link m-0 p-0" style={{fontSize:".875rem"}}
                                    onClick={(e) =>
                                        handleLinkButtonRedirect(
                                            process.env.REACT_APP_CDC_BASE_URL,
                                            false
                                        )
                                    }
                                >
                                    CDC
                                </button>
                            </li>
                            <li className="breadcrumb-item">
                                <button
                                    className="btn btn-link m-0 p-0" style={{ fontSize: ".875rem" }}
                                    onClick={(e) =>
                                        handleLinkButtonRedirect(
                                            process.env.REACT_APP_CDI_POPULATION_HEALTH_URL,
                                            false
                                        )
                                    }
                                >
                                    Division of Population Health
                                </button>
                                
                            </li>
                            <li className="breadcrumb-item">
                                <button
                                    className="btn btn-link m-0 p-0" style={{ fontSize: ".875rem" }}
                                    onClick={(e) =>
                                        handleLinkButtonRedirect(
                                            process.env.REACT_APP_CDI_BASE_URL,
                                            false
                                        )
                                    }
                                >
                                    Chronic Disease Indicators
                                </button>                                
                            </li>
                        </ul>
                    </nav>
                </div>
            </div>
        </div>
    );
};

export default BreadCrumbAndMenu;
